import { FileText, ListChecks, LayoutGrid, Sparkles, Building2, Users } from 'lucide-react';
import { PK_COLORS } from '../PathkitLogo';

const features = [
  {
    icon: FileText,
    title: 'Scope intake & SOW analysis',
    body: 'Paste an SOW, get structured config items, gaps, and risks back in seconds. Save the analysis or run it again as the scope evolves.',
  },
  {
    icon: ListChecks,
    title: 'Discovery Grid',
    body: 'Guided client questionnaires with auto-generated next questions so consultants never miss a detail before build.',
  },
  {
    icon: LayoutGrid,
    title: 'Spaces & Config Items',
    body: 'Model your client\u2019s service-desk topology \u2014 spaces, request types, workflows, fields \u2014 before you touch the live system.',
  },
  {
    icon: Sparkles,
    title: 'AI assistance with privacy guarantees',
    body: 'OpenAI-backed suggestions and transcription. We never use your data to train models.',
    cta: { label: 'See AI Data Use', href: '/ai-trust' },
  },
  {
    icon: Building2,
    title: 'Multi-tenant by design',
    body: 'Every consulting firm gets its own subdomain, its data is kept separate, and access is checked on every request. Custom domains available on Enterprise.',
  },
  {
    icon: Users,
    title: 'Roles built for consulting',
    body: 'System Admin, Firm Admin, Client Engagement Lead, and Client roles ship with sensible defaults. View-as lets admins debug without losing context.',
  },
];

export function MarketingFeatures() {
  return (
    <section
      id="features"
      className="py-20 md:py-24"
      style={{ backgroundColor: '#F8FAFC' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2
            className="text-3xl md:text-4xl font-semibold tracking-tight"
            style={{ color: PK_COLORS.navy }}
          >
            Everything you need to scope, design, and deliver
          </h2>
          <p className="mt-4 text-slate-600">
            PathKit replaces the spreadsheet-of-spreadsheets that most service desk teams use to
            keep client engagements moving.
          </p>
        </div>

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <li
                key={f.title}
                className="group rounded-xl border border-slate-200 bg-white p-6 hover:shadow-sm transition-shadow"
              >
                <span
                  className="inline-flex items-center justify-center w-10 h-10 rounded-lg"
                  style={{ backgroundColor: `${PK_COLORS.navy}0F`, color: PK_COLORS.navy }}
                  aria-hidden
                >
                  <Icon className="w-5 h-5" />
                </span>
                <h3
                  className="mt-4 text-lg font-semibold"
                  style={{ color: PK_COLORS.navy }}
                >
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.body}</p>
                {f.cta && (
                  <a
                    href={f.cta.href}
                    className="mt-3 inline-block text-sm font-medium hover:underline"
                    style={{ color: PK_COLORS.teal }}
                  >
                    {f.cta.label} &rarr;
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
